import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { ToastrService } from 'ngx-toastr';
import { setConclusioniProposteListeners } from './conclusioni-proposte.listeners';
import { setConclusioniScadenzeListeners } from './conclusioni-scadenze.listeners';
import { setConclusioniIrregolaritaListeners } from './conclusioni-irregolarita.listeners';
import { my_FirmaLegaleListenerHelper } from './conclusioni-firma-legale.listeners';

export class ConclusioniFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;
    private readonly toastrService: ToastrService;

    constructor(form: FormGroup, store: Store<Revisione53State>, toastrService: ToastrService) {
        super(form);
        this.store = store;
        this.toastrService = toastrService;
    }

    setListeners(): void {
        setConclusioniProposteListeners(this.form, this.store);
        setConclusioniScadenzeListeners(this.form, this.store);
        setConclusioniIrregolaritaListeners(this.form, this.store);
        my_FirmaLegaleListenerHelper(this.form, this.store);
    }
}
